import { render, staticRenderFns } from "./SimpleTextMarker.vue?vue&type=template&id=6a26e8f5&scoped=true"
import script from "./SimpleTextMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleTextMarker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SimpleTextMarker.vue?vue&type=style&index=0&id=6a26e8f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26e8f5",
  null
  
)

export default component.exports